<app-dialog-base titleTranslationKey="users.user-form.edit-profile-picture">
  <ng-container content>
    <img id="fake" [src]="thumbnailPhotoFake" style="display: none" />
    <div class="content">
      <div class="info">
        <div class="format">
          {{ 'users.user-form.file-format' | translate }}
          <br />
          .bmp .jpeg .jpg .png
        </div>
        <div class="ratio">
          {{ 'users.user-form.ratio' | translate }}
          <br />
          1:1
        </div>
        <div class="size">
          {{ 'users.user-form.size' | translate }}
          <br />
          max 4MB
        </div>
      </div>
      <img *ngIf="thumbnailPhoto" class="avatar" [src]="thumbnailPhoto" width="250px" height="250px" />
      <img *ngIf="!thumbnailPhoto" class="avatar" src="../../../assets/icons/profile_pic_empty.svg" width="250px" height="250px" />
      <div class="actions">
        <app-link-button icon="upload" [text]="'users.user-form.edit' | translate" (clicked)="editPicture()"></app-link-button>
        <app-link-button
          icon="delete"
          [text]="'users.user-form.delete' | translate"
          [disabled]="!thumbnailPhoto"
          (clicked)="deletePicture()"
        ></app-link-button>
      </div>
    </div>
  </ng-container>

  <ng-container actions>
    <button mat-flat-button [routerLink]="[]" (click)="closeDialog()" mat-button>{{ 'shared.cancel' | translate | uppercase }}</button>
    <button mat-flat-button color="primary" (click)="saveDialog()" mat-button>
      {{ 'shared.save' | translate | uppercase }}
    </button>
  </ng-container>
</app-dialog-base>
